import React, { memo } from "react";

const Info = ():JSX.Element => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      fill='none'
      viewBox='0 0 18 18'
    >
      <path
        fill='#000'
        d='M9 18c-4.962 0-9-4.038-9-9s4.038-9 9-9 9 4.038 9 9-4.038 9-9 9zM9 1.125C4.657 1.125 1.125 4.657 1.125 9c0 4.342 3.532 7.875 7.875 7.875 4.342 0 7.875-3.533 7.875-7.875 0-4.343-3.533-7.875-7.875-7.875z'
      ></path>
      <path
        fill='#000'
        d='M9.563 7.313H8.437v5.625h1.126V7.311zM9.563 4.5H8.437v1.125h1.126V4.5z'
      ></path>
    </svg>
  );
}

export default memo(Info);
